import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SessionStorageService } from '../../services/session-storage.service';
import { AdminService } from '../admin.service';

@Component({
    selector: 'app-legacy-profile-history',
    templateUrl: './legacy-profile-history.component.html',
    styleUrls: ['./legacy-profile-history.component.scss'],
    standalone: false
})
export class LegacyProfileHistoryComponent implements OnInit {
  private admnSrvc = inject(AdminService);
  private route = inject(ActivatedRoute);
  private ss = inject(SessionStorageService);

  profile;
  changeSummary;
  loading = false;
  solution;
  rights = [];

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.profile = params['params']['profileId'];
      this.solution = params['params']['solution']?.toLowerCase();
    });
    this.getProfileHistory();
    this.rights = this.ss.get('rights') ? this.ss.get('rights') : [];
  }

  getProfileHistory() {
    this.loading = true;
    this.admnSrvc
      .getProfileHistory(this.profile, this.solution)
      .subscribe(x => {
        this.changeSummary = x.results;
        this.loading = false;
      });
  }
}
